import React, { useEffect, useState } from "react";
import "./ScorePopUp.css";
import axios from "../../../axios";
import { useSelector } from "react-redux";
import { IP } from "../../../internalServer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function ScorePopUp({ isOpen, assessmentId, handleViewAnswer, completeAss, completedCard, handleViewAnswerQuestionFalse }) {
  const [scoreBoard, setScoreBoard] = useState();
  const [leaderBoard, setLeaderBoard] = useState([]);
  const [isGettingData, setIsGettingData] = useState();
  const [studentResultData, setStudentResultData] = useState([])
  const userId = useSelector((state) => state?.user?.currentUser?.id);


  useEffect(() => {
    getStudentResponse();
  }, []);

  const getStudentResponse = async () => {
    try {
      let res = await axios.get(
        `/assessment/${assessmentId}/studentResult/student/${userId}/get`
      );
      console.log("resCompleted", res)
      if (res) {
        setStudentResultData(res.data.data)
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setLeaderBoard([]);
    setScoreBoard();
    setIsGettingData(true);

    const completedBox = async () => {
      try {
        let response = await axios.get(
          `/assessment/${assessmentId}/studentScoreBoard/get/studentId/${userId}`
        );

        response && setScoreBoard(response.data.data);

        let res = await axios.get(
          `/assessment/${assessmentId}/studentLeaderBoard/get`
        );
        if (res) {
          let array = res.data.data;
          const targetIndex = array.findIndex(
            (obj) => obj?.student?.id === userId
          );

          // Move the object with the target ID to the beginning of the array
          if (targetIndex !== -1) {
            const targetObj = array[targetIndex];
            array?.splice(targetIndex, 1);
            array?.unshift(targetObj);
          }

          setLeaderBoard(array);
        }
        setIsGettingData(false);
      } catch (error) {
        console.log(error);
      }
    };
    completedBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessmentId]);
  const sortedLeaders = leaderBoard.sort((a, b) => a.rank - b.rank);
  return (
    <div className={`ScorePopUpContainer ${isOpen && "isOpened"}`}>
      {scoreBoard && leaderBoard?.length > 0 ? (
        <div className="ScorePopUpContainer" style={{ position: "relative" }}>
          <div style={{ position: "absolute", top: "12px", right: "12px", zIndex: "999" }}>
            <FontAwesomeIcon
              icon={faXmark}
              style={{ cursor: "pointer", fontSize: "20px" }}
              onClick={handleViewAnswerQuestionFalse}
            />
          </div>
          <div className="imgContainerScore">
            <img
              src="/DCM-img/ScoreTrophy.png"
              className="imgScore"
              class="img-fluid"
              alt=""
            ></img>
            <div className="imgTexscore">
              Good Keep improving, {scoreBoard?.student?.name.split(" ")[0]}!
            </div>
          </div>
          <div className="subContainerScoreDetail p-3 pb-0 mt-1">
            <div className="d-flex justify-content-between">
              <span className="ScoreTitle">Your Score</span>
              {
                completeAss.checkAdaptive ? (<span className="ScoreSubTitle">
                  {studentResultData.ability?.toFixed(2)}
                </span>) : (<span className="ScoreSubTitle">
                  {scoreBoard?.obtained_marks}/{scoreBoard?.total_marks}
                </span>)
              }
            </div>
            {completeAss.checkAdaptive ? null : (<div className="d-flex justify-content-between">
              <span className="ScoreTitle">CGPA</span>
              <span className="ScoreSubTitle">
                {Math.round(
                  (scoreBoard?.obtained_marks / scoreBoard?.total_marks) * 100
                )}
                %
              </span>
            </div>)}
            <div className="d-flex justify-content-between">
              <span className="ScoreTitle">Rank</span>
              <span className="ScoreSubTitle">{scoreBoard?.rank.toString().padStart(2, "0")}</span>
            </div>
            <div className="d-flex justify-content-between">
              <span className="ScoreTitle">Duration</span>
              <span className="ScoreSubTitle">
                {scoreBoard?.total_duration} min
              </span>
            </div>

            <div className="horizontalLineAss mt-2"></div>
            <div className="mt-2 d-flex justify-content-between mt-3">
              <span className="HeaderScore">Total Questions</span>
              <span className="HeaderScore">{scoreBoard?.total_questions.toString().padStart(2, "0")}</span>
            </div>
            {completeAss.checkAdaptive ? null :
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <span className="ScoreTitle">Attempted</span> &nbsp;
                  <span className="ScoreSubTitle">
                    {scoreBoard?.attempted_questions.toString().padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <span className="ScoreTitle">Unattempted</span> &nbsp;
                  <span className="ScoreSubTitle">
                    {scoreBoard?.unattempted_questions.toString().padStart(2, "0")}
                  </span>
                </div>
              </div>}

            <div className="d-flex justify-content-between">
              <div>
                <span className="ScoreTitle mr-4 pr-1">Correct</span>
                <span className="ScoreSubTitle">
                  {(Number(scoreBoard?.correct_answers) + Number(scoreBoard?.partially_correct_answers)).toString().padStart(2, "0")}
                </span>
              </div>
              <div>
                <span className="ScoreTitle">incorrect</span> &nbsp;
                <span className="ScoreSubTitle">
                  {scoreBoard?.incorrect_answers.toString().padStart(2, "0")}
                </span>
              </div>
            </div>

            <div className="horizontalLineAss mt-2"></div>
            <div className="mt-2">
              <span className="HeaderScore">Leader Board</span>
            </div>

            <div className="LeaderBoardContainer" style={{
              height: completeAss.checkAdaptive ? '42%' : '30%',
            }}>
              {sortedLeaders?.length > 0 &&
                sortedLeaders?.map((leader, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-between mt-2"
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          leader?.student?.profile_picture
                            ? IP + leader?.student?.profile_picture.replace(/^\./, "")
                            : leader?.student?.gender === "M"
                              ? leader?.student?.avatarProfile ? '/images/Boys/' + leader?.student?.avatarProfile + '.webp'
                                : "/images/Student_boy_pic.png"
                              : leader?.student?.gender === "F"
                                ? leader?.student?.avatarProfile ? '/images/Girls/' + leader?.student?.avatarProfile + '.webp'
                                  : "/images/Student_girl_pic.png"
                                : "/images/default image.png"
                        }
                        alt="icon"
                        className=""
                        style={{ width: "20px", height: "20px", borderRadius: "50%", cursor: "pointer" }}
                        key={leader?.student?.avatarProfile}
                        onError={(e) => {
                          if (leader?.student?.gender === "M") {
                            e.target.src = leader?.student?.avatarProfile ? '/images/Boys/' + leader?.student?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                          } else {
                            e.target.src = leader?.student?.avatarProfile ? '/images/Girls/' + leader?.student?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                          }
                        }}
                      />
                      &nbsp;
                      <span className="studentNameScore">
                        {leader?.student?.name}
                      </span>
                      &nbsp;
                      {leader?.student?.id === userId && (
                        <span className="YouText">👈 You</span>
                      )}
                    </div>
                    <div className="d-flex align-items-center ">
                      <span className="ScoreTitle mr-1">Rank</span> &nbsp;
                      <span className="ScoreSubTitle">
                        {console.log("leader", leader)}
                        {leader?.rank.toString().padStart(2, "0")}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
            <div className=" d-flex justify-content-center mt-4 ">
              <button
                className="ViewAnswersBtn d-flex justify-content-center align-items-center"
                onClick={handleViewAnswer}
              >
                View Answers
              </button>
            </div>
          </div>
        </div>
      ) : isGettingData ? (
        <img className="leader_loader" src="/gif/LoaderDot.gif" alt="" />
      ) : (
        <span>Result Not Found</span>
      )
      }
    </div >
  );
}
